import { render, staticRenderFns } from "./SponsorFooter.vue?vue&type=template&id=306e3ec4&scoped=true&"
var script = {}
import style0 from "./SponsorFooter.vue?vue&type=style&index=0&id=306e3ec4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306e3ec4",
  null
  
)

export default component.exports